module.exports = __webpack_public_path__ + "img/work_time.7ac4e7a4.svg";